import React from "react";
import bellIcon from "../../assets/icons/bellIcon.png";

/**
 * Shared Push Notification phone-mockup preview, same visual style the compose page
 * (PushNotification.js) already used (".mobile-image" / ".notification-card" in App.css -
 * actual phone frame image, not a hand-drawn SVG). Reused in three places instead of three
 * separate, slightly different implementations: the compose page's own preview, the Automation
 * Push node's preview, and the Sent/Scheduled Message details page's preview (MessageReport.js).
 *
 * `showImage` lets the caller decide whether the image should render (compose page only shows
 * it once the URL/upload is confirmed valid) - pass true whenever there's nothing to validate
 * (e.g. a sent/saved message where the image is already known good).
 */
export default function PushNotificationPreview({
    appName,
    title,
    message,
    imageUrl,
    showImage = true,
    onImageError,
    actionButtons = [],
}) {
    return (
        <div className="mobile-image d-block">
            <div className="notification-card">
                <div className="profile">
                    <img src={bellIcon} height="2px" alt="Profile" />
                </div>
                <div style={{ width: "85%" }}>
                    <div>
                        <p style={{ fontSize: "12px" }}>{appName}</p>
                    </div>
                    <div>
                        <p style={{ fontSize: "14px", marginBottom: "2px" }}><b>{title}</b></p>
                        <p style={{ color: message ? "black" : "gray", fontSize: "14px", marginBottom: "8px" }}>
                            {message || "Default message"}
                        </p>
                        {showImage && imageUrl ? (
                            <img
                                src={imageUrl}
                                alt="Selected"
                                style={{ padding: "2px", width: "85%", height: "auto" }}
                                onError={onImageError}
                            />
                        ) : null}
                        {actionButtons.length > 0 && (
                            <div>
                                {actionButtons.map((button, index) => (
                                    <button id="notification-button" style={{ border: "0", marginRight: "5px" }} key={button.id || index}>
                                        {button.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
